import {hideElement, showElement} from "../visibility/showHide.js";
import {removeElements} from "./auth-misc-functions.js";
import {authAccountElements, authElements} from "./auth-account-elements.js";


/**
 * Переключает интерфейс формы в режим регистрации.
 * Управляет видимостью полей (пароли, email, капча, аватар) и меняет текст кнопки сабмита.
 *
 * @param {number} s - Флаг сценария регистрации
 * @returns {void}
 */

const switchToRegistrationMode = (s) => {
    if (authElements.ttAuthHiddenField) {
        authElements.ttAuthHiddenField.value = 'reg';
    }

    if (authElements.ttAuthBtn) {
        authElements.ttAuthBtn.disabled = false;
    }

    showElement(authElements.ttAuthAvaDiv);
    showElement(authElements.ttAuthCapDiv);

    removeElements('.g-message');

    hideElement(authAccountElements.ttAuthPassword);
    hideElement(authAccountElements.ttAuthPasswordNew);

    if (s === 1) {
        if (authAccountElements.ttAuthPassword) {
            authAccountElements.ttAuthPassword.value = '';
        }
    } else {
        hideElement(authElements.ttAuthEmail);
    }

    if (authElements.ttAuthBtn) {
        authElements.ttAuthBtn.value = 'Зарегистрировать';
    }

    if (authElements.ttAuthTabRegistration && authElements.ttAuthTabEnter) {
        authElements.ttAuthTabRegistration.classList.add('active');
        authElements.ttAuthTabEnter.classList.remove('active');
    }
}

export default switchToRegistrationMode;